import { render, staticRenderFns } from "./ProfeeTables.vue?vue&type=template&id=3aa9ca5c&scoped=true&"
import script from "./ProfeeTables.vue?vue&type=script&lang=js&"
export * from "./ProfeeTables.vue?vue&type=script&lang=js&"
import style0 from "./ProfeeTables.vue?vue&type=style&index=0&id=3aa9ca5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa9ca5c",
  null
  
)

export default component.exports